import { PageHeader } from "./PageHeader";

export default function LegalPageLayout({ eyebrow, title, intro, lastUpdated, highlights = [], sections = [] }) {
  return (
    <>
      <PageHeader eyebrow={eyebrow} title={title} intro={intro}>
        <div className="mt-6 inline-flex rounded-full theme-surface px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] theme-text-muted">
          Last updated: {lastUpdated}
        </div>
      </PageHeader>

      <section className="section-pad">
        <div className="container-x grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
          <aside className="space-y-5">
            <div className="rounded-3xl theme-surface p-6 sm:p-8 shadow-sm">
              <div className="eyebrow mb-4">Quick Summary</div>
              <div className="space-y-3">
                {highlights.map((item, index) => (
                  <div key={index} className="rounded-2xl theme-bg-secondary px-4 py-4 text-sm leading-relaxed theme-text-secondary">
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </aside>

          <div className="rounded-3xl theme-surface p-6 sm:p-8 md:p-10 shadow-sm">
            <div className="space-y-10">
              {sections.map((section) => (
                <section key={section.heading}>
                  <h2 className="font-display text-2xl sm:text-3xl font-bold theme-text-primary tracking-tight">
                    {section.heading}
                  </h2>
                  <div className="divider-gold mt-4 mb-5" />
                  <div className="space-y-4 text-sm sm:text-base leading-relaxed theme-text-secondary">
                    {section.paragraphs.map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                </section>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
